import './sass/main.scss';
import lorem from './ecmascript/main';
